import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { mapFirebaseError } from "./errorMapper";
async function resizeImage(file, maxSize) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
            let { width, height } = img;
            if (width > maxSize || height > maxSize) {
                const ratio = Math.min(maxSize / width, maxSize / height);
                width = Math.round(width * ratio);
                height = Math.round(height * ratio);
            }
            const canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);
            canvas.toBlob((blob) => {
                if (blob)
                    resolve(blob);
                else
                    reject(new Error("Failed to compress image"));
            }, "image/jpeg", 0.7);
        };
        img.onerror = () => reject(new Error("Failed to load image"));
        img.src = URL.createObjectURL(file);
    });
}
export class FirebaseProfileImageStorage {
    storage = getStorage();
    async uploadProfileImage(file, userId) {
        try {
            const resized = await resizeImage(file, 512);
            const storageRef = ref(this.storage, `profile_images/${userId}/profile.jpg`);
            await uploadBytes(storageRef, resized, { contentType: "image/jpeg" });
            return await getDownloadURL(storageRef);
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
}
//# sourceMappingURL=FirebaseProfileImageStorage.js.map